export default __webpack_public_path__ + "static/media/background-logo.73a47cf0.svg";